import { render, staticRenderFns } from "./statuses.vue?vue&type=template&id=5edbe1df&scoped=true"
import script from "./statuses.vue?vue&type=script&lang=ts"
export * from "./statuses.vue?vue&type=script&lang=ts"
import style0 from "./statuses.vue?vue&type=style&index=0&id=5edbe1df&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edbe1df",
  null
  
)

export default component.exports